import moment from 'moment';

const EventCommentMapper = {
  toCommentList: comments =>
    comments.map(comment => ({
      id: comment.Id,
      comment: comment.Comment,
      externalUserId: comment.ExternalUserId,
      externalUserName: comment.ExternalUserName,
      modifiedDate: moment(comment.ModifiedDate).format('YYYY/MM/DD'),
      modifiedTime: moment(comment.ModifiedDate).format('hh:mm A'),
      accessibilities: comment.Accessibilities.map(x => ({
        accessibility: x.Accessibility,
        targetUserId: x.TargetUserId,
        title: x.Title
      })),
      commentTo: comment.Accessibilities.map(x => x.Title).join(', '),
      isEditable: comment.IsEditable,
      isDeletable: comment.IsDeletable,
      type: comment.Type,
      actionType: comment.ActionType,
      isSystemSender: comment.IsSystemSender
    }))
};

export default EventCommentMapper;
